import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      transform="scale(1.5 1.5)"
      d="M13.42 9.58667C13.5512 9.71803 13.6552 9.87396 13.7261 10.0455C13.797 10.2171 13.8335 10.401 13.8333 10.5867C13.8333 10.9615 13.6844 11.321 13.4193 11.586C13.1543 11.8511 12.7948 12 12.42 12H4.57996C4.20512 12 3.84563 11.8511 3.58058 11.586C3.31553 11.321 3.16663 10.9615 3.16663 10.5867C3.16646 10.401 3.20288 10.2171 3.2738 10.0455C3.34472 9.87396 3.44876 9.71803 3.57996 9.58667L4.49996 8.66667V6C4.49996 4.93913 4.92139 3.92172 5.67153 3.17157C6.42168 2.42143 7.43909 2 8.49996 2C9.56083 2 10.5782 2.42143 11.3284 3.17157C12.0785 3.92172 12.5 4.93913 12.5 6V8.66667L13.42 9.58667ZM10.5 12H6.49996C6.49996 12.5304 6.71067 13.0391 7.08575 13.4142C7.46082 13.7893 7.96953 14 8.49996 14C9.03039 14 9.5391 13.7893 9.91417 13.4142C10.2892 13.0391 10.5 12.5304 10.5 12Z"
      stroke={fill}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
);

export default Icon;
